var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 base-section-title user-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }